
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"14","height":"14","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_26784_4382)"}},[_c('path',{attrs:{"d":"M9.88.928c.78-.743 2.034-.76 2.816-.014l.63.602c.8.763.78 2.007-.014 2.765l-.52.494a.593.593 0 01-.102.137l-7.703 7.4a.6.6 0 01-.245.14l-3.77 1.123a.6.6 0 01-.746-.751l1.117-3.636a.601.601 0 01.158-.257l7.702-7.398a.6.6 0 01.15-.104l.528-.5zM1.703 12.106l1.922-.573-1.349-1.297-.573 1.87zm1.24-2.895l1.768 1.7L11.4 4.486l-.88-.821-.902-.867L2.94 9.211zm8.926-7.43c-.307-.292-.832-.297-1.16.015l-.2.19.841.809.9.84.235-.222a.698.698 0 00.015-1.029l-.631-.602z","fill":"#fff"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_26784_4382"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h14v14H0z"}})])])])
          )
        }
      }
    